module.exports = __webpack_public_path__ + "cb794527a5eebf141f43bb28ecb9d45c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/sleeping-3.png
// module id = 2172
// module chunks = 0